import React, { useEffect } from "react";
import { useGetApplicationQuery, usePostUpsertApplicationMutation } from "@/store/service";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { ApplicationStep } from "@/enum/ApplicationStep";
import Applicants from "@/model/interface/form/Applicants";
import ApiApplicationApplicant from "@/model/interface/api/ApiApplicationApplicant";
import ApplicantCurrentMortgage from "./ApplicantCurrentMortgage";
import { isDebugForms, getDebugNextStepUrl } from "@/util/debug";
import { applicantsMortgageSchema } from "@/model/schemas";
import { zodFormResolver } from "@/util/form";

const ApplicantCurrentMortgageWrapper = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { data: application, isLoading } = useGetApplicationQuery(params.id!);
  const [postApplication, postApplicationResult] = usePostUpsertApplicationMutation();
  const applicant =
    application?.applicants?.find((applicant) => applicant.type === "MainApplicant") ?? ({} as ApiApplicationApplicant);

  const form = useForm<Applicants>({
    resolver: zodFormResolver<Applicants>(applicantsMortgageSchema),
    mode: "onTouched",
    defaultValues: {},
  });
  const { control, watch, register, formState, handleSubmit, getValues } = form;

  useEffect(() => {
    if (postApplicationResult.isSuccess) {
      navigate(`/application/${postApplicationResult.data.id}/${postApplicationResult.data.step}`);
      return;
    }
  }, [postApplicationResult.isSuccess]);

  const onSubmit = async (data: Applicants) => {
    const applicants = [data.mainApplicant];
    if (data.coApplicant) {
      applicants.push(data.coApplicant);
    }

    await postApplication({ applicants, id: params.id!, step: ApplicationStep.Applicant });
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isDebugForms()) {
      navigate(getDebugNextStepUrl(params.id!, ApplicationStep.ApplicantCurrentMortgage, params.type));
    } else {
      handleSubmit(onSubmit)(e);
    }
  };

  return (
    <form onSubmit={handleFormSubmit} className="relative">
      <div className="w-full max-w-2xl mx-auto space-y-5">
        <h3 className="text-2xl font-semibold text-gray-900 text-center">Current mortgage</h3>
        <ApplicantCurrentMortgage form={form} applicant={applicant} applicantType={"mainApplicant"} />
        <div className="flex justify-center pt-2">
          <button
            type="submit"
            name="submit"
            className="inline-flex items-center rounded-full bg-[#9BFBE0] px-8 py-3 text-sm font-medium text-[#010305] shadow-sm hover:shadow-md transition-all"
          >
            Continue
          </button>
        </div>
      </div>
    </form>
  );
};

export default ApplicantCurrentMortgageWrapper;
